var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#small-pin-office';
                    var viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#view-small-pin-office';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?small-pin-office#small-pin-office';
                            viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?small-pin-office#view-small-pin-office';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 22 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };